import React, { useRef, useState } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import './preview.css';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null); // varsa

  const scrollToSection = (id) => {
    const sectionRefs = {
      home: homeRef,
      about: aboutRef,
      services: servicesRef,
      contact: contactRef
    };

    sectionRefs[id]?.current?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const navItems = [
    { id: 'home', label: 'Ana Sayfa' },
    { id: 'about', label: 'Hakkında' },
    { id: 'services', label: 'Çalışma Alanı' },
    { id: 'contact', label: 'İletişim' }
  ];

  return (
    <>
      <Header
        navItems={navItems}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        scrollToSection={scrollToSection}
      />
      <main>
        <div ref={homeRef}><Home scrollToSection={scrollToSection} /></div>
        <div ref={aboutRef}><About /></div>
        <div ref={servicesRef}><Services /></div>
        <div ref={contactRef}><Contact /></div>
      </main>
    </>
  );
}

export default App;
